var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 183,
    viewBox: "0 0 103 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3455 91.8199C86.6469 97.3396 102.141 113.935 102.141 136.351C102.141 163.929 79.6373 183 51.3126 183C21.5654 183 0.613281 161.352 0.613281 136.352C0.613281 125.937 3.77301 116.961 9.07056 109.749L8.09391 61.2108H12.6876C19.8656 76.4162 33.9345 89.6893 53.4588 89.6893C59.4887 89.6893 67.2404 87.4988 67.2404 81.0554C67.2404 73.4522 57.9093 70.2305 51.4492 67.6534L40.5387 63.2725C19.7219 54.8958 9.09868 43.6852 9.09868 29.639C9.09868 10.8249 24.1724 0 44.2704 0C52.3099 0 60.0625 2.19048 67.24 5.28381L82.7456 0H86.0477L87.1957 29.5102H83.3198C76.1414 15.5924 62.934 3.47944 44.8451 3.47944C39.3894 3.47944 32.6424 6.05648 32.6424 11.8557C32.6424 18.8137 42.1172 21.6493 47.8603 24.3552L77.1466 37.7571C86.3345 42.0097 94.2304 52.3187 94.2304 64.3024C94.2304 80.9492 81.5312 88.9179 66.3455 91.8199ZM42.6475 109.806V169.727C42.6475 174.881 45.4927 179.521 51.3126 179.521C57.5205 179.521 60.1073 174.882 60.1073 169.727V109.806C60.1073 103.363 59.9781 93.3116 51.3126 93.3116C43.035 93.3116 42.6475 103.363 42.6475 109.806Z",
    fill: "#FFFFFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e4af83d9276eb56c48402d573243833.svg";
export { ForwardRef as ReactComponent };